'use client';

import { ROUTES, useClientConfig } from '@shared/utils';
import { useSearchParams } from 'next/navigation';
import { BackChevron } from '../../../BackChevron/BackChevron';
import { GraphicContainer } from '../../../GraphicContainer/GraphicContainer';
import { isAllRewardsClaimedBundleStatus } from '../../helpers/offerHelpers';
import { OfferValidityBadge } from '../OfferValidityBadge/OfferValidityBadge';

type OfferHeaderProps = {
  title: string;
  expirationDate?: string | null;
  bundleStatus?: string;
  images?: {
    mobile?: string;
    desktop?: string;
  };
  fallbackImage?: string;
};

function OfferHeader({ title, expirationDate, bundleStatus, images, fallbackImage = '/images/casino-headline.jpg' }: OfferHeaderProps) {
  const params = useSearchParams();
  const comesFromLogin = params.get('registration-success') === 'true';
  const { baseImgUrl } = useClientConfig();
  const isCompleted = bundleStatus === 'COMPLETED';
  const isExpired = bundleStatus === 'EXPIRED';
  const shouldShowValidityBadge = Boolean(expirationDate) && !isAllRewardsClaimedBundleStatus(bundleStatus);

  return (
    <>
      <div className="relative overflow-hidden md:rounded-lg">
        {!comesFromLogin ? <BackChevron fallbackUrl={ROUTES.OFFERS} variant="primary" headerVariant="subheader" className="absolute top-5 left-5 z-10" /> : null}

        <GraphicContainer
          className="h-44 md:hidden border-background-secondary"
          imageClassName="border border-background-secondary"
          image={{
            src: images?.mobile ? new URL(images.mobile, baseImgUrl).toString() : fallbackImage,
            alt: 'Casino Offers Background',
          }}
        />
        <GraphicContainer
          className="h-44 hidden md:block border-background-secondary"
          imageClassName="border border-background-secondary"
          image={{
            src: images?.desktop ? new URL(images.desktop, baseImgUrl).toString() : fallbackImage,
            alt: 'Casino Offers Background',
          }}
        />

        <div className="mx-5 md:mx-8 mt-6 mb-4">
          {shouldShowValidityBadge ? <OfferValidityBadge validUntil={expirationDate!} isCompleted={isCompleted} isExpired={isExpired} data-testid="offer-validity-badge" /> : null}
          <h4 className="heading-4 mt-4" data-testid="offer-header-title">
            {title}
          </h4>
        </div>
      </div>
    </>
  );
}

export { OfferHeader, type OfferHeaderProps };
